<template>
  <section class="business-section py-20 bg-gradient-to-b from-gray-50 to-white">
    <div class="container mx-auto px-4">
      <div class="text-center mb-16">
        <h2 class="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent">业务板块</h2>
        <p class="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">chmura云通讯为全球客户提供创新的ICT解决方案,业务涵盖运营商网络、政企客户、消费者终端等多个领域。</p>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
        <!-- 运营商业务 -->
        <div class="business-card group scroll-animate" :style="{ backgroundImage: `url(${businessCards[0].bgImage})` }">
          <div class="card-overlay"></div>
          <div class="card-content">
            <div class="icon-container mb-6">
              <i :class="businessCards[0].icon + ' text-3xl'"></i>
            </div>
            <h3 class="text-2xl font-bold mb-4 text-white">{{ businessCards[0].title }}</h3>
            <p class="text-white text-opacity-90 mb-8 leading-relaxed">{{ businessCards[0].description }}</p>
            <div class="flex justify-end mt-auto">
              <span class="learn-more-btn">
                了解更多 <i class="fas fa-arrow-right ml-2 arrow-icon"></i>
              </span>
            </div>
          </div>
        </div>
        
        <!-- 政企业务 -->
        <div class="business-card group scroll-animate delay-200" :style="{ backgroundImage: `url(${businessCards[1].bgImage})` }">
          <div class="card-overlay"></div>
          <div class="card-content">
            <div class="icon-container mb-6">
              <i :class="businessCards[1].icon + ' text-3xl'"></i>
            </div>
            <h3 class="text-2xl font-bold mb-4 text-white">{{ businessCards[1].title }}</h3>
            <p class="text-white text-opacity-90 mb-8 leading-relaxed">{{ businessCards[1].description }}</p>
            <div class="flex justify-end mt-auto">
              <span class="learn-more-btn">
                了解更多 <i class="fas fa-arrow-right ml-2 arrow-icon"></i>
              </span>
            </div>
          </div>
        </div>
        
        <!-- 消费者业务 -->
        <div class="business-card group scroll-animate delay-400" :style="{ backgroundImage: `url(${businessCards[2].bgImage})` }">
          <div class="card-overlay"></div>
          <div class="card-content">
            <div class="icon-container mb-6">
              <i :class="businessCards[2].icon + ' text-3xl'"></i>
            </div>
            <h3 class="text-2xl font-bold mb-4 text-white">{{ businessCards[2].title }}</h3>
            <p class="text-white text-opacity-90 mb-8 leading-relaxed">{{ businessCards[2].description }}</p>
            <div class="flex justify-end mt-auto">
              <span class="learn-more-btn">
                了解更多 <i class="fas fa-arrow-right ml-2 arrow-icon"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BusinessSection',
  data() {
    return {
      businessCards: [
        {
          title: '运营商业务',
          icon: 'fas fa-tower-cell',
          description: '为全球运营商客户提供5G、光传输、数据通信等全方位解决方案,助力构建高效、可靠的通信网络。',
          bgImage: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80' // 网络科技背景
        },
        {
          title: '政企业务',
          icon: 'fas fa-building',
          description: '为政府和企业客户提供云计算、大数据、物联网等数字化转型解决方案,助力各行业实现智能化升级。',
          bgImage: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80' // 现代建筑/办公背景
        },
        {
          title: '消费者业务',
          icon: 'fas fa-mobile-alt',
          description: '提供智能终端、家庭终端等产品,打造智能、便捷的数字生活体验,满足消费者对高品质智能终端的需求。',
          bgImage: 'https://images.unsplash.com/photo-1558002038-1055907df827?w=800&q=80' // 智能设备背景
        }
      ]
    }
  }
}
</script>

<style scoped>
.business-section {
  font-family: 'Arial', 'Microsoft YaHei', sans-serif;
  position: relative;
}

.business-card {
  position: relative;
  height: 100%;
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

/* 背景图片遮罩层 */
.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.85) 0%, rgba(37, 99, 235, 0.9) 100%);
  transition: all 0.4s ease;
  z-index: 1;
}

.business-card:hover .card-overlay {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.75) 0%, rgba(37, 99, 235, 0.8) 100%);
}

.business-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #60a5fa, #ffffff);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
  z-index: 2;
}

.business-card:hover::before {
  transform: scaleX(1);
}

.business-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 20px 40px rgba(59, 130, 246, 0.3), 0 8px 16px rgba(0, 0, 0, 0.2);
}

.card-content {
  padding: 2.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
}

.icon-container {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: all 0.4s ease;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.business-card:hover .icon-container {
  transform: scale(1.1) rotate(5deg);
  background: rgba(255, 255, 255, 0.35);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3);
}

.learn-more-btn {
  color: white;
  font-weight: 600;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  padding: 0.5rem 0;
}

.learn-more-btn::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: white;
  transition: width 0.3s ease;
}

.business-card:hover .learn-more-btn::after {
  width: 100%;
}

.business-card:hover .learn-more-btn {
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.arrow-icon {
  transition: transform 0.3s ease;
}

.business-card:hover .arrow-icon {
  transform: translateX(5px);
}

/* 滚动动画延迟 */
.delay-200 {
  transition-delay: 0.1s;
}

.delay-400 {
  transition-delay: 0.2s;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .card-content {
    padding: 2rem;
  }
  
  .icon-container {
    width: 70px;
    height: 70px;
  }
}
</style>